import AssetsSelector from './selector.vue'
import SelectorWithModal from './selector-with-wrapper.vue'
import { makeSelectorForm } from './utils'

// 导出带modal的常用组件
export default SelectorWithModal
// 导出本体，适用于需定制modal 例如：uc批量添加创意组
export { AssetsSelector, makeSelectorForm }
